// extracted by mini-css-extract-plugin
export var alignCenter = "_b8-d";
export var bannerShown = "_b8-6";
export var buttonContent = "_b8-0";
export var cardList = "_b8-1";
export var centerContent = "_b8-2";
export var chevron = "_b8-3";
export var closePanelButton = "_b8-k";
export var conversationContextContainer = "_b8-l";
export var conversationDetailContainer = "_b8-4";
export var detailWrapper = "_b8-7";
export var dropdownButton = "_b8-e";
export var dropdownTitle = "_b8-9";
export var fullHeight = "_b8-5";
export var hidden = "_b8-a";
export var icon = "_b8-b";
export var mergeSuggestionWrapper = "_b8-m";
export var panel = "_b8-i";
export var portalButtonsWrapper = "_b8-c";
export var right = "_b8-j";
export var tableSummaryContainer = "_b8-8";
export var tableSummaryHeader = "_b8-g";
export var threeDotsButton = "_b8-f";
export var wide = "_b8-h";